import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FeatureFlag } from '@mode/shared/contract-common';
import { getInitialFlagValue, HelpDocsService } from '@mode/shared/util-js';

@Component({
  selector: 'mode-python-intro',
  templateUrl: './python-intro.component.html',
  styleUrl: './python-intro.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PythonIntroComponent {
  isRegisterImportedDatasetEnabled = getInitialFlagValue(FeatureFlag.RegisterImportedDatasetsNotebooks);
  @Input() itemExpandedOrCollapsed!: Record<string, boolean>;
  @Output() toggle = new EventEmitter<string>();
  @Output() goToSupportedLibraries = new EventEmitter<void>();
  @Output() goToKeyboardShortcuts = new EventEmitter<void>();

  constructor(public helpDocs: HelpDocsService) {}

  toggleSection(section: string) {
    this.toggle.emit(section);
  }

  isOpenSection(topic: string): boolean {
    return !!this.itemExpandedOrCollapsed[topic];
  }
}
